import { translate } from '@/core/localization/translate';
export const {
  discount,
  quantity,
  unitPrice
} = translate({
  "quantity": "Quantity",
  "unitPrice": "Price (unit)",
  "discount": "Discount"
});